import { Autocomplete, Box, Paper, TextField, ThemeProvider, createTheme, useTheme } from '@mui/material';
import { DiscoverTvType } from '@tmdb-graphql-api/schema/types';
import { type FormikErrors } from 'formik';
import { type MovieFormikValues } from '../types.ts';

export type TvTypeMultiSelectDropdownProps = {
  ariaLabelledBy: string;
  name: string;
  setFieldValue: (
    field: string,
    value: any, // eslint-disable-line @typescript-eslint/no-explicit-any
    shouldValidate?: boolean,
  ) => Promise<FormikErrors<MovieFormikValues>> | Promise<void>;
  value: { id: DiscoverTvType; name: string }[];
};

export const tvTypeOptions = [
  {
    id: DiscoverTvType.Documentary,
    name: 'Documentary',
  },
  {
    id: DiscoverTvType.Miniseries,
    name: 'Miniseries',
  },
  {
    id: DiscoverTvType.News,
    name: 'News',
  },
  {
    id: DiscoverTvType.Reality,
    name: 'Reality',
  },
  {
    id: DiscoverTvType.Scripted,
    name: 'Scripted',
  },
  {
    id: DiscoverTvType.TalkShow,
    name: 'Talk Show',
  },
  {
    id: DiscoverTvType.Video,
    name: 'Video',
  },
];

export const TvTypeMultiSelectDropdown = ({
  ariaLabelledBy,
  name,
  setFieldValue,
  value,
}: TvTypeMultiSelectDropdownProps) => {
  const theme = useTheme();

  return (
    <ThemeProvider theme={createTheme({ ...theme, palette: { mode: 'dark' } })}>
      <Autocomplete
        aria-labelledby={ariaLabelledBy}
        autoComplete
        clearIcon=""
        filterSelectedOptions
        getOptionLabel={option => option.name}
        includeInputInList
        multiple
        noOptionsText=""
        onChange={(_e, option) => {
          void setFieldValue(name, option);
        }}
        options={tvTypeOptions}
        renderInput={params => <TextField {...params} fullWidth hiddenLabel placeholder="Enter name" />}
        renderOption={(props, renderOpts) => (
          <Box component="li" {...props} key={renderOpts.id}>
            {renderOpts.name}
          </Box>
        )}
        slots={{
          paper: params => <Paper {...params} sx={{ backgroundColor: '#222' }} />,
        }}
        value={value}
      />
    </ThemeProvider>
  );
};
